import { Grid } from '@mui/material';
import ProcureVendorForm from '../../components/vendors/ProcureVendorForm';
import { useState } from 'react';
import { useMutation } from '@apollo/client';
import {
  createProcureVendor as createProcureVendorMutation,
  getProcureVendorById,
} from 'vendor-marketplace-shared-library';
import { PROCURE_VENDOR_CREATE_ERROR } from '../../error-messages';
import useAlert from '../../hooks/useAlert';
import { useNavigate } from 'react-router-dom';
import { ProcureVendorFormInput } from '../../types/vendors';
import { AddressInput } from '../../types/google-maps';

export default function CreateVendorPage() {
  const alert = useAlert();
  const navigate = useNavigate();
  const [procureVendorFormInput, setProcureVendorFormInput] = useState<ProcureVendorFormInput>({
    name: '',
    phone: '',
    email: '',
    issueTypeIds: [],
    propertyIds: [],
    procureVendorContacts: [],
  });

  const [address, setAddress] = useState<AddressInput>({
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipcode: '',
  });

  const [createProcureVendor] = useMutation(createProcureVendorMutation, {
    variables: {
      input: { ...procureVendorFormInput, ...address },
    },
    refetchQueries: [getProcureVendorById],
    onError: () => {
      alert.setAlert({ message: PROCURE_VENDOR_CREATE_ERROR });
    },
    onCompleted: data => {
      navigate(`/vendors/${data.createProcureVendor.id}`);
    },
  });

  return (
    <Grid container>
      <Grid item xs={0} md={3} />
      <Grid item xs={12} md={6}>
        <ProcureVendorForm
          procureVendorFormInput={procureVendorFormInput}
          setProcureVendorFormInput={setProcureVendorFormInput}
          address={address}
          setAddress={setAddress}
          onSubmit={createProcureVendor}
        />
      </Grid>
      <Grid item xs={0} md={3} />
    </Grid>
  );
}
